/**
 * OCHAT: the sidebar layout choices Ochat makes differently from upstream.
 *
 * These are flags rather than deletions on purpose. Ochat used to delete
 * upstream's markup and imports outright, which meant every upstream refactor of
 * the sidebar fought with the fork and the resolution was manual. Gating with
 * `v-if` leaves upstream's code in place, so a merge just works and turning a
 * choice back on is a one-line change here.
 */
export const OCHAT_SIDEBAR = {
  /**
   * Replace upstream's account switcher with the Ochat wordmark plus an explicit
   * collapse toggle. Ochat instances are single-account, so the switcher only
   * ever showed one entry.
   */
  useBrandHeader: true,

  /**
   * Hide upstream's "compose conversation" pen button. Outbound conversations in
   * Ochat start from Marketing (broadcasts), not from the sidebar.
   */
  hideComposeButton: true,

  /** Show the account logo and name at the foot of the sidebar. */
  showAccountFooter: true,
};

export default OCHAT_SIDEBAR;
